export default __webpack_public_path__ + "ede6a1d70862683a13bbe94c1b2e2d3c.svg";